import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { push } from 'react-router-redux';

import { Button } from '@milanote/roma';
import type { BaseLinkProps } from '@milanote/roma';

type RouteLinkButtonProps = Omit<BaseLinkProps, 'ref'> & {
    to: string;
    location?: Location;
    keepParams?: boolean;
};

const RouteLinkButton = ({
    className,
    children,
    to,
    location,
    keepParams = false,
    color = 'link-color',
    ...rest
}: RouteLinkButtonProps) => {
    const destination = keepParams && location ? `${to}${location.search}` : to;

    const dispatch = useDispatch();
    const dispatchNavigation = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        dispatch(push(destination));
    };

    return (
        <Button
            {...rest}
            className={classNames('RouteLink', className)}
            onClick={dispatchNavigation}
            href={destination}
            color={color}
        >
            {children}
        </Button>
    );
};

RouteLinkButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    to: PropTypes.string,
    className: PropTypes.string,
    location: PropTypes.object,
    keepParams: PropTypes.bool,
};

export default RouteLinkButton;
